/* True Beauty theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var store = {
    get: function (k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v === null ? d : v; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Drawers & overlay ---------- */
  var overlay = $('[data-overlay]');
  var openDrawerEl = null;
  var lastTrigger = null;

  function openDrawer(name, trigger) {
    var el = $('[data-drawer="' + name + '"]');
    if (!el) return;
    closeDrawer(true);
    lastTrigger = trigger || null;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    openDrawerEl = el;
    if (overlay) overlay.hidden = false;
    document.body.classList.add('is-locked');
    var focusTarget = $('input[type="search"]', el) || el;
    setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 60);
  }

  function closeDrawer(keepOverlayState) {
    if (openDrawerEl) {
      openDrawerEl.classList.remove('is-open');
      openDrawerEl.setAttribute('aria-hidden', 'true');
      openDrawerEl = null;
    }
    var filters = $('[data-filters].is-open');
    if (filters) filters.classList.remove('is-open');
    if (!keepOverlayState) {
      if (overlay) overlay.hidden = true;
      document.body.classList.remove('is-locked');
      if (lastTrigger) { lastTrigger.focus({ preventScroll: true }); lastTrigger = null; }
    }
  }

  /* ---------- Cart ---------- */
  function updateCartBubbles(count) {
    $$('.count-bubble[data-cart-count]').forEach(function (b) { b.textContent = count; });
  }

  function refreshCart() {
    return fetch((T.routes.root || '/') + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-drawer-inner]', doc);
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          current.setAttribute('data-cart-count', fresh.getAttribute('data-cart-count'));
          updateCartBubbles(fresh.getAttribute('data-cart-count'));
        }
      });
  }

  function changeLine(line, qty) {
    return fetch(T.routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(refreshCart);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-cart-form]')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch(T.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = res.data.description || res.data.message || T.strings.added_error;
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { alert(msg); }
          return;
        }
        return refreshCart().then(function () { openDrawer('cart', btn); });
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = T.strings.added_error; errorEl.hidden = false; }
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  });

  /* ---------- Global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open'), opener); return; }

    if (t.closest('[data-drawer-close]') || t === overlay) { closeDrawer(); return; }

    /* Header dropdowns (currency, sign in): close any open one the click landed outside of */
    $$('details[data-dropdown][open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });

    var annClose = t.closest('[data-announcement-close]');
    if (annClose) {
      var bar = annClose.closest('[data-announcement]');
      if (bar) bar.hidden = true;
      try { sessionStorage.setItem('tb_announcement', annClose.dataset.announcementKey); } catch (err) {}
      return;
    }

    var slideNav = t.closest('[data-slide-prev], [data-slide-next]');
    if (slideNav) {
      var host = slideNav.closest('[data-slideshow]');
      if (host && host._step) host._step(slideNav.hasAttribute('data-slide-next') ? 1 : -1);
      return;
    }

    var lineBtn = t.closest('[data-line-qty]');
    if (lineBtn) { lineBtn.disabled = true; changeLine(lineBtn.dataset.line, lineBtn.dataset.qty); return; }

    var minus = t.closest('[data-qty-minus]');
    var plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      var input = $('[data-qty-input]', (minus || plus).closest('.qty'));
      if (input) {
        var min = input.getAttribute('min') === '0' ? 0 : 1;
        var next = Math.max(min, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    if (t.closest('[data-back-to-top]')) { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }

    var wish = t.closest('[data-wishlist-toggle]');
    if (wish) { e.preventDefault(); toggleWishlist(wish.dataset.handle, wish); return; }

    var thumb = t.closest('[data-thumb]');
    if (thumb) { showMedia(thumb.closest('[data-product-section]'), thumb.dataset.thumb); return; }

    var ft = t.closest('[data-filter-toggle]');
    if (ft) {
      var panel = $('[data-filters]');
      if (panel) {
        var willOpen = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', willOpen);
        if (overlay) overlay.hidden = !willOpen;
        document.body.classList.toggle('is-locked', willOpen);
      }
      return;
    }

    var recover = t.closest('[data-toggle-recover]');
    if (recover) { e.preventDefault(); var r = $('#recover'); if (r) r.hidden = !r.hidden; return; }

    if (t.closest('[data-cookie-accept]')) { store.set('tb_cookie', 1); var cb = $('[data-cookie-bar]'); if (cb) cb.hidden = true; return; }

    var tabBtn = t.closest('[data-tab]');
    if (tabBtn) { switchTab(tabBtn); return; }

    var dot = t.closest('[data-slide-dot]');
    if (dot) { var ss = dot.closest('[data-slideshow]'); if (ss && ss._goTo) ss._goTo(Number(dot.dataset.slideDot), true); return; }

    if (t.closest('[data-modal-close]') || (t.classList && t.classList.contains('modal'))) { closeModal(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeModal(); closeCompare(); $$('details[data-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); }); }
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches && el.matches('[data-auto-submit]')) {
      var form = el.form;
      if (!form) return;
      if (form.matches('[data-cart-page-form]')) {
        var upd = $('[name="update"]', form);
        form.requestSubmit ? form.requestSubmit(upd) : form.submit();
      } else if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }
    if (el.matches && el.matches('[data-option]')) onOptionChange(el.closest('[data-product-section]'));
  });

  /* ---------- Carousels ---------- */
  function initCarousel(root) {
    if (root._init) return;
    root._init = true;
    var track = $('.carousel__track', root);
    if (!track) return;
    var items = $$('.carousel__item', track).filter(function (li) { return !li.classList.contains('carousel__item--empty'); });
    var dotsWrap = $('[data-carousel-dots]', root);
    var prev = $('[data-carousel-prev]', root);
    var next = $('[data-carousel-next]', root);

    if (dotsWrap) {
      dotsWrap.innerHTML = items.map(function (_, i) {
        return '<button type="button" class="dot" aria-label="Go to item ' + (i + 1) + '"></button>';
      }).join('');
      $$('.dot', dotsWrap).forEach(function (d, i) {
        d.addEventListener('click', function () {
          track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
    }

    function update() {
      if (!items.length) return;
      var left = track.scrollLeft, best = 0, bestDist = Infinity;
      items.forEach(function (it, i) {
        var dist = Math.abs(it.offsetLeft - track.offsetLeft - left);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      if (dotsWrap) $$('.dot', dotsWrap).forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
      if (prev) prev.disabled = left <= 2;
      if (next) next.disabled = left + track.clientWidth >= track.scrollWidth - 2;
    }

    function step(dir) {
      var w = items[0] ? items[0].getBoundingClientRect().width + 20 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    root._update = update;
    update();
  }

  /* ---------- Slideshow ---------- */
  function initSlideshow(root) {
    var slides = $$('[data-slide]', root);
    var dots = $$('[data-slide-dot]', root);
    if (slides.length < 2) return;
    var index = 0, timer = null;
    var delay = (parseInt(root.dataset.autoplay, 10) || 0) * 1000;

    function goTo(i, user) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        var a = $('a', s); if (a) a.tabIndex = on ? 0 : -1;
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); d.setAttribute('aria-selected', n === index); });
      if (user) restart();
    }
    function restart() {
      clearInterval(timer);
      if (delay && !reduceMotion) timer = setInterval(function () { goTo(index + 1); }, delay);
    }
    root._goTo = goTo;
    root._step = function (d) { goTo(index + d, true); };

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1), true);
      startX = null;
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    restart();
  }

  /* ---------- Tabs ---------- */
  function switchTab(btn) {
    var wrap = btn.closest('[data-tabs]');
    if (!wrap) return;
    var id = btn.dataset.tab;
    $$('[data-tab]', wrap).forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on);
    });
    $$('[data-tab-panel]', wrap).forEach(function (p) {
      var on = p.dataset.tabPanel === id;
      p.hidden = !on;
      if (on) $$('.carousel', p).forEach(function (c) { initCarousel(c); if (c._update) c._update(); });
    });
  }

  /* ---------- Wishlist ---------- */
  function getWishlist() { return store.get('tb_wishlist', []); }
  function applyWishlist() {
    var list = getWishlist();
    $$('[data-wishlist-toggle]').forEach(function (b) {
      var on = list.indexOf(b.dataset.handle) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
      var label = $('[data-wish-label]', b);
      if (label) label.textContent = on ? 'In your wishlist' : 'Add to wishlist';
    });
    $$('[data-wishlist-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
    applyCompare();
  }
  function toggleWishlist(handle, btn) {
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    store.set('tb_wishlist', list);
    applyWishlist();
    var page = btn.closest('[data-wishlist-page]');
    if (page && i > -1) {
      var li = btn.closest('li'); if (li) li.remove();
      if (!page.children.length) { var empty = $('[data-wishlist-empty]'); if (empty) empty.hidden = false; }
    }
  }
  function loadWishlistPage() {
    var grid = $('[data-wishlist-page]');
    if (!grid) return;
    var list = getWishlist();
    var empty = $('[data-wishlist-empty]');
    if (!list.length) { if (empty) empty.hidden = false; return; }
    var base = (T.routes.root || '/').replace(/\/$/, '');
    Promise.all(list.map(function (h) {
      return fetch(base + '/products/' + encodeURIComponent(h) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      grid.innerHTML = parts.join('');
      if (!grid.children.length && empty) empty.hidden = false;
      applyWishlist();
    });
  }

  /* ---------- Product page ---------- */
  function showMedia(section, id) {
    if (!section || !id) return;
    $$('[data-media-id]', section).forEach(function (m) { m.hidden = String(m.dataset.mediaId) !== String(id); });
    $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)); });
  }

  function onOptionChange(section) {
    if (!section) return;
    var dataEl = $('[data-variants]', section);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var selected = $$('[data-option]:checked', section)
      .sort(function (a, b) { return a.dataset.position - b.dataset.position; })
      .map(function (i) { return i.value; });
    var match = variants.filter(function (v) {
      return selected.every(function (val, idx) { return v['option' + (idx + 1)] === val; });
    })[0];
    var atc = $('[data-atc]', section);
    var idInput = $('[data-variant-id]', section);

    if (!match) {
      if (atc) atc.innerHTML = '<button type="button" class="btn btn--block" disabled>Unavailable</button>';
      return;
    }
    if (idInput) idInput.value = match.id;
    var subEl = $('[data-subtotal]', section);
    if (subEl) { subEl.dataset.cents = match.price; updateSubtotal(section); }
    var availEl = $('[data-availability]', section);
    if (availEl) availEl.textContent = match.available ? 'In stock' : 'Out of stock';
    var stickySel = $('[data-sticky-variant]'), stickyBtn = $('[data-sticky-add]');
    if (stickySel) stickySel.value = match.id;
    if (stickyBtn) stickyBtn.disabled = !match.available;
    if (match.featured_media && match.featured_media.id) showMedia(section, match.featured_media.id);
    history.replaceState(null, '', '?variant=' + match.id);

    fetch(section.dataset.productUrl + '?variant=' + match.id + '&section_id=' + encodeURIComponent(section.dataset.sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPrice = $('[data-price]', doc), curPrice = $('[data-price]', section);
        var newAtc = $('[data-atc]', doc);
        if (newPrice && curPrice) curPrice.innerHTML = newPrice.innerHTML;
        if (newAtc && atc) atc.innerHTML = newAtc.innerHTML;
        if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
        applyWishlist();
      });
  }

  function loadRecommendations() {
    $$('[data-recommendations]').forEach(function (wrap) {
      var url = wrap.dataset.url;
      var target = $('[data-recommendations-target]', wrap);
      if (!url || !target) return;
      var run = function () {
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = $('[data-recommendations-inner]', doc);
          if (inner) {
            target.innerHTML = inner.innerHTML;
            $$('.carousel', target).forEach(initCarousel);
            applyWishlist();
          }
        }).catch(function () { /* recommendations are optional */ });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); run(); }
        }, { rootMargin: '400px' });
        io.observe(wrap);
      } else { run(); }
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    var input = $('[data-search-input]');
    var results = $('[data-predictive-results]');
    var trending = $('[data-search-trending]');
    if (!input || !results) return;
    var timer = null, controller = null;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; if (trending) trending.hidden = false; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var params = new URLSearchParams({ q: q, section_id: 'predictive-search' });
        params.append('resources[type]', 'product');
        params.append('resources[limit]', '6');
        fetch(T.routes.predictive_search + '?' + params.toString(), controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = $('[data-predictive-inner]', doc);
            results.innerHTML = inner ? inner.innerHTML : '';
            if (trending) trending.hidden = true;
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- Modal, cookie, back-to-top ---------- */
  var modal = null;
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    store.set('tb_newsletter', Date.now());
    document.body.classList.remove('is-locked');
  }
  function initModal() {
    modal = $('[data-newsletter-popup]');
    if (!modal) return;
    var posted = /customer_posted=true/.test(location.search);
    var last = store.get('tb_newsletter', 0);
    var sevenDays = 7 * 24 * 60 * 60 * 1000;
    if (posted) { modal.hidden = false; return; }
    if (Date.now() - last < sevenDays) return;
    var delay = (parseInt(modal.dataset.delay, 10) || 8) * 1000;
    setTimeout(function () {
      if (openDrawerEl) return;
      modal.hidden = false;
      var f = $('input[type="email"]', modal); if (f) f.focus({ preventScroll: true });
    }, delay);
  }

  function initFloating() {
    var cookie = $('[data-cookie-bar]');
    if (cookie && !store.get('tb_cookie', 0)) cookie.hidden = false;
    var top = $('[data-back-to-top]');
    if (top) {
      var toggle = function () { top.hidden = window.scrollY < 500; };
      window.addEventListener('scroll', toggle, { passive: true });
      toggle();
    }
  }

  /* ---------- Init ---------- */


  /* ---------- Compare products ---------- */
  var CMP_KEY = 'tb_compare', cmpOpener = null, cmpMsgTimer;
  var CLOSE_SVG = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function getCompare() { var l = store.get(CMP_KEY, []); return Array.isArray(l) ? l : []; }
  function compareMax() { return parseInt(T.compareMax, 10) || 4; }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function imgAt(u, w) {
    if (!u) return '';
    u = String(u).replace(/^\/\//, 'https://');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function plainText(html, words) {
    var text = new DOMParser().parseFromString(html || '', 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
    var parts = text.split(' ');
    return parts.length > words ? parts.slice(0, words).join(' ') + '…' : text;
  }

  function applyCompare() {
    var list = getCompare();
    $$('[data-compare-toggle]').forEach(function (b) {
      var on = list.indexOf(b.dataset.handle) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var bar = $('[data-compare-bar]');
    if (bar) {
      bar.hidden = !list.length;
      var c = $('[data-compare-count]', bar);
      if (c) c.textContent = list.length;
    }
  }

  function compareMsg(text) {
    var el = $('[data-compare-msg]');
    if (!el) return;
    el.textContent = text;
    clearTimeout(cmpMsgTimer);
    cmpMsgTimer = setTimeout(function () { el.textContent = ''; }, 3500);
  }

  function closeCompare() {
    var m = $('[data-compare]');
    if (!m || m.hidden) return;
    m.hidden = true;
    document.body.classList.remove('is-locked');
    if (cmpOpener && cmpOpener.focus) cmpOpener.focus();
  }

  function openCompare(opener) {
    var m = $('[data-compare]');
    if (!m) return;
    cmpOpener = opener || null;
    m.hidden = false;
    document.body.classList.add('is-locked');
    var close = $('.compare__head [data-compare-close]', m);
    if (close) close.focus();
    renderCompare();
  }

  function renderCompare() {
    var body = $('[data-compare-body]'), list = getCompare();
    if (!body) return;
    if (!list.length) { body.innerHTML = '<p class="compare__empty">Nothing to compare yet. Use the compare icon on any product.</p>'; return; }
    body.innerHTML = '<p class="compare__empty">Loading…</p>';
    var base = (T.routes.root || '/').replace(/\/$/, '');
    Promise.all(list.map(function (h) {
      return fetch(base + '/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) { body.innerHTML = '<p class="compare__empty">These products are no longer available.</p>'; return; }
      var money = function (c) { return esc(formatMoney(c, T.moneyFormat)); };
      var optNames = [];
      products.forEach(function (p) {
        (p.options || []).forEach(function (o) {
          var n = o && o.name ? o.name : o;
          if (n && n !== 'Title' && optNames.indexOf(n) < 0) optNames.push(n);
        });
      });
      function optValues(p, name) {
        var idx = -1;
        (p.options || []).forEach(function (o, i) { if ((o && o.name ? o.name : o) === name) idx = i; });
        if (idx < 0) return '–';
        var o = p.options[idx];
        if (o && o.values) return esc(o.values.join(', '));
        var seen = [];
        p.variants.forEach(function (v) { var val = v['option' + (idx + 1)]; if (val && seen.indexOf(val) < 0) seen.push(val); });
        return esc(seen.join(', ') || '–');
      }
      function row(label, fn) {
        return '<tr><th scope="row">' + esc(label) + '</th>' + products.map(function (p) { return '<td>' + fn(p) + '</td>'; }).join('') + '</tr>';
      }
      var html = '<div class="compare__scroll"><table class="compare__table"><tbody>';
      html += row('Products', function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        var action;
        if (!p.available) action = '<span class="compare__soldout">Sold out</span>';
        else if (p.variants.length === 1) action = '<form action="' + esc(T.routes.cart_add) + '" method="post" data-cart-form><input type="hidden" name="id" value="' + esc(v.id) + '"><button type="submit" class="btn btn--small">Add to cart</button></form>';
        else action = '<a class="btn btn--outline btn--small" href="' + esc(p.url) + '">Choose options</a>';
        return '<div class="compare__item">' +
          '<button type="button" class="compare__remove" data-compare-remove="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + '">' + CLOSE_SVG + '</button>' +
          '<a href="' + esc(p.url) + '"><img src="' + esc(imgAt(p.featured_image, 320)) + '" alt="" loading="lazy"></a>' +
          '<a class="compare__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="compare__price">' + money(p.price) + (p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</span>' +
          action + '</div>';
      });
      html += row('Description', function (p) { return esc(plainText(p.description, 28)) || '–'; });
      html += row('Availability', function (p) { return p.available ? 'In stock' : 'Out of stock'; });
      html += row('Brand', function (p) { return esc(p.vendor) || '–'; });
      html += row('Product type', function (p) { return esc(p.type) || '–'; });
      optNames.forEach(function (n) { html += row(n, function (p) { return optValues(p, n); }); });
      html += '</tbody></table></div>';
      body.innerHTML = html;
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var tgl = t.closest('[data-compare-toggle]');
    if (tgl) {
      e.preventDefault();
      var h = tgl.dataset.handle, list = getCompare(), i = list.indexOf(h);
      if (i > -1) list.splice(i, 1);
      else {
        if (list.length >= compareMax()) { compareMsg(T.strings.compare_full || 'You can compare up to ' + compareMax() + ' products.'); return; }
        list.push(h);
      }
      store.set(CMP_KEY, list);
      applyCompare();
      return;
    }
    var open = t.closest('[data-compare-open]');
    if (open) { openCompare(open); return; }
    if (t.closest('[data-compare-close]')) { closeCompare(); return; }
    if (t.closest('[data-compare-clear]')) { store.set(CMP_KEY, []); applyCompare(); closeCompare(); return; }
    var rm = t.closest('[data-compare-remove]');
    if (rm) {
      var left = getCompare().filter(function (x) { return x !== rm.dataset.compareRemove; });
      store.set(CMP_KEY, left);
      applyCompare();
      if (left.length) renderCompare(); else closeCompare();
    }
  });
  // adding to cart from the compare table: close it first so the cart drawer is not hidden behind it
  document.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest('[data-compare]')) closeCompare();
  }, true);

  /* ---------- Money + product page extras ---------- */
  function formatMoney(cents, format) {
    format = format || '{{amount}}';
    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      var v = (n / 100).toFixed(precision).split('.');
      return v[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (v[1] ? decimal + v[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/), t = m ? m[1] : 'amount', out;
    switch (t) {
      case 'amount_no_decimals': out = num(cents, 0); break;
      case 'amount_with_comma_separator': out = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = num(cents, 2, "'", '.'); break;
      default: out = num(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function updateSubtotal(section) {
    var el = $('[data-subtotal]', section);
    if (!el) return;
    var input = $('[data-qty-input]', section);
    var qty = input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
    el.textContent = formatMoney((parseInt(el.dataset.cents, 10) || 0) * qty, section.dataset.moneyFormat);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    var section = $('[data-product-section]');
    if (t.matches('[data-qty-input]') && section) {
      var main = $('[data-qty-input]', section), sticky = $('[data-sticky-qty]');
      if (t === main && sticky) sticky.value = main.value;
      else if (t === sticky && main) main.value = sticky.value;
      updateSubtotal(section);
    }
    if (t.matches('[data-sticky-variant]') && section) {
      var dataEl = $('[data-variants]', section);
      if (!dataEl) return;
      var v = JSON.parse(dataEl.textContent).filter(function (x) { return String(x.id) === t.value; })[0];
      if (!v) return;
      var last;
      [v.option1, v.option2, v.option3].forEach(function (val, i) {
        if (val == null) return;
        $$('[data-option][data-position="' + (i + 1) + '"]', section).forEach(function (r) { if (r.value === val) { r.checked = true; last = r; } });
      });
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]'), section = $('[data-product-section]');
    if (!bar || !section || bar._ready) return;
    bar._ready = true;
    var target = $('[data-atc]', section);
    function toggle(show) { bar.hidden = !show; document.body.classList.toggle('has-sticky-atc', show); }
    if ('IntersectionObserver' in window && target) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        toggle(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(target);
    }
    var add = $('[data-sticky-add]', bar);
    if (add) add.addEventListener('click', function () {
      var form = $('form.product-form', section);
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
    updateSubtotal(section);
  }

  function trackRecentlyViewed() {
    var sec = $('[data-product-section]');
    if (!sec || !sec.dataset.handle) return;
    var list = store.get('tb_recent', []).filter(function (h) { return h !== sec.dataset.handle; });
    list.unshift(sec.dataset.handle);
    store.set('tb_recent', list.slice(0, 16));
  }

  function loadRecentlyViewed() {
    var wrap = $('[data-recently-viewed]');
    if (!wrap) return;
    var sec = $('[data-product-section]');
    var current = sec ? sec.dataset.handle : '';
    var list = store.get('tb_recent', []).filter(function (h) { return h !== current; }).slice(0, parseInt(wrap.dataset.limit, 10) || 8);
    if (!list.length) return;
    var track = $('[data-recently-viewed-track]', wrap);
    var base = (T.routes.root || '/').replace(/\/$/, '');
    Promise.all(list.map(function (h) {
      return fetch(base + '/products/' + encodeURIComponent(h) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.join('').replace(/<li>/g, '<li class="carousel__item">');
      if (!html.trim()) return;
      track.innerHTML = html;
      wrap.hidden = false;
      initCarousel($('.carousel', wrap));
      applyWishlist();
    });
  }

  /* ---------- Sticky header (desktop: announcement bar + compact single row after scrolling) ---------- */
  function initStickyHeader() {
    var header = $('.site-header');
    if (!header || header.dataset.sticky === 'false') return;
    var ann = $('[data-announcement]');
    var mq = window.matchMedia('(min-width: 990px)');
    var spacer = document.createElement('div');
    spacer.className = 'site-header-spacer';
    header.parentNode.insertBefore(spacer, header.nextSibling);
    var stuck = false, ticking = false, threshold = 0, headerH = 0, annH = 0;
    function annHeight() { return ann && !ann.hidden ? ann.offsetHeight : 0; }
    function measure() {
      if (!stuck) threshold = header.getBoundingClientRect().bottom + (window.pageYOffset || 0);
    }
    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var should = mq.matches && y > threshold + 40;
      if (should === stuck) return;
      if (should) {
        // Both the announcement bar and the header leave the page flow, so the spacer holds their combined height.
        headerH = header.offsetHeight;
        annH = annHeight();
        spacer.style.height = (headerH + annH) + 'px';
        spacer.style.display = 'block';
        header.style.setProperty('--announce-h', annH + 'px');
      }
      stuck = should;
      header.classList.toggle('is-stuck', stuck);
      if (ann) ann.classList.toggle('is-pinned', stuck && annH > 0);
      if (!stuck) { spacer.style.display = 'none'; spacer.style.height = ''; header.style.removeProperty('--announce-h'); measure(); }
    }
    // Visitor closes the announcement bar while the header is pinned: pull the header up and shrink the spacer.
    if (ann && window.MutationObserver) {
      new MutationObserver(function () {
        if (!stuck) { measure(); return; }
        var now = annHeight();
        threshold -= (annH - now);
        annH = now;
        spacer.style.height = (headerH + annH) + 'px';
        header.style.setProperty('--announce-h', annH + 'px');
        ann.classList.toggle('is-pinned', annH > 0);
      }).observe(ann, { attributes: true, attributeFilter: ['hidden'] });
    }
    measure();
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', function () { measure(); update(); });
    update();
  }

  /* ---------- Collection page: category tree, view as, items per page, show more ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-cat-toggle]');
    if (!toggle) return;
    var item = toggle.closest('.cat-tree__item');
    var list = item && $('.cat-tree__list', item);
    if (!list) return;
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    list.hidden = !open;
  });

  function initCollectionGrid() {
    var grid = $('[data-collection-grid]');
    if (!grid) return;

    // Grid / list
    var mode = store.get('tb_view', 'grid');
    function applyView(m) {
      grid.classList.toggle('product-grid--list', m === 'list');
      $$('[data-view]').forEach(function (b) {
        var on = b.dataset.view === m;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    applyView(mode);
    $$('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () { store.set('tb_view', b.dataset.view); applyView(b.dataset.view); });
    });

    // Items per page + Show more (client side on top of Shopify's own pagination)
    var perSel = $('[data-per-page]'), moreBtn = $('[data-show-more]'), moreWrap = $('[data-more-wrap]');
    if (!perSel || !moreBtn) return;
    var perWrap = $('[data-per-page-wrap]');
    if (perWrap) perWrap.hidden = false;
    var saved = parseInt(store.get('tb_pp', 0), 10);
    if (saved && $$('option', perSel).some(function (o) { return parseInt(o.value, 10) === saved; })) perSel.value = String(saved);
    var perPage = parseInt(perSel.value, 10) || 24;
    var href = moreBtn.getAttribute('href');
    var nextUrl = href && href !== '#' ? href : null;
    var shown = perPage, busy = false;

    function items() { return $$(':scope > li', grid); }
    function render() {
      var list = items();
      list.forEach(function (li, i) { li.hidden = i >= shown; });
      if (moreWrap) moreWrap.hidden = !(shown < list.length || nextUrl);
      moreBtn.classList.remove('is-loading');
    }
    function fetchNext() {
      if (!nextUrl || busy) return Promise.resolve(false);
      busy = true;
      return fetch(nextUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        $$('[data-collection-grid] > li', doc).forEach(function (li) {
          var node = document.importNode(li, true);
          node.hidden = true;
          grid.appendChild(node);
        });
        var nextBtn = $('[data-show-more]', doc), nh = nextBtn && nextBtn.getAttribute('href');
        nextUrl = nh && nh !== '#' ? nh : null;
        busy = false;
        return true;
      }).catch(function () { busy = false; nextUrl = null; return false; });
    }
    function ensure(target) {
      if (items().length >= target || !nextUrl) return Promise.resolve();
      return fetchNext().then(function (ok) { return ok ? ensure(target) : null; });
    }
    function showCount(n) {
      shown = n;
      return ensure(n).then(function () { render(); applyWishlist(); });
    }

    moreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      moreBtn.classList.add('is-loading');
      showCount(shown + perPage);
    });
    perSel.addEventListener('change', function () {
      perPage = parseInt(perSel.value, 10) || 24;
      store.set('tb_pp', perPage);
      showCount(perPage);
    });
    showCount(perPage);
  }

  function init() {
    $$('.carousel').forEach(function (c) {
      if (c.closest('[data-tab-panel][hidden]')) return; // initialised when the tab opens
      initCarousel(c);
    });
    $$('[data-slideshow]').forEach(initSlideshow);
    applyWishlist();
    loadWishlistPage();
    loadRecommendations();
    initSearch();
    initModal();
    initFloating();
    initStickyHeader();
    initCollectionGrid();
    initStickyAtc();
    trackRecentlyViewed();
    loadRecentlyViewed();
    var recover = $('#recover');
    if (recover && (location.hash === '#recover' || $('.form-status--success', recover))) recover.hidden = false;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor: re-run when sections are reloaded
  document.addEventListener('shopify:section:load', function () { $$('.carousel').forEach(function (c) { c._init = false; initCarousel(c); }); $$('[data-slideshow]').forEach(initSlideshow); applyWishlist(); });
})();
